import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Api from "../../services/Api";
import toast from "react-hot-toast";
import logo from "../../asessts/Images/logo.png";
import loginImg from "../../asessts/Images/login_img.png";
import passwordIcon from "../../asessts/Images/Password_icon.svg";
import eyeIcon from "../../asessts/Images/eye_icon.svg";
import eyeSlashIcon from "../../asessts/Images/eye_close.svg";

function ResetPassword() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const creds = JSON.parse(localStorage.getItem("careCred") || "{}");

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      setIsLoading(true);

      const passwordData = {
        newPassword: password,
        confirmPassword,
        email: creds.email,
      };

      const response = await Api.resetPasswordAfterOtp(passwordData);

      if (response.status) {
        toast.success("Password changed successfully");
        localStorage.removeItem("flowType");
        localStorage.removeItem("careToken");
        localStorage.removeItem("careCred");
        navigate("/");
      } else {
        toast.error(response.message || "Something went wrong");
      }

      setIsLoading(false);
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to reset password");
      setIsLoading(false);
    }
  };

  return (
    <div className="for-overlay">
      <section id="Dashboard-login-main">
        <div className="dashboard-input-left">
          <div className="logo">
            <a href="#">
              <img src={logo} alt="Logo" />
            </a>
          </div>
          <div className="login-input-details">
            <h2>Password Reset</h2>
            <p>Please reset your password</p>
            <form onSubmit={handleChangePassword}>
              {/* New Password Field */}
              <div className="input-group mb">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="New Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <span className="icon">
                  <img
                    className="mobile-icon"
                    src={passwordIcon}
                    alt="Password"
                  />
                </span>
                <span
                  className="eye-icon"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <img
                    src={showPassword ? eyeIcon : eyeSlashIcon}
                    alt="Toggle Password"
                  />
                </span>
              </div>

              {/* Confirm Password Field */}
              <div className="input-group mb">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
                <span className="icon">
                  <img
                    className="mobile-icon"
                    src={passwordIcon}
                    alt="Password"
                  />
                </span>
                <span
                  className="eye-icon"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  <img
                    src={showConfirmPassword ? eyeIcon : eyeSlashIcon}
                    alt="Toggle Confirm"
                  />
                </span>
              </div>

              <div className="login-btn">
                <button type="submit" disabled={isLoading}>
                  {isLoading ? "Changing..." : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>

        <div className="login-img-right">
          <img src={loginImg} alt="Login Visual" />
        </div>
      </section>
    </div>
  );
}

export default ResetPassword;
